import {
  icon_restoration_pontic_1,
  icon_restoration_pontic_2,
  icon_restoration_pontic_3,
  icon_restoration_pontic_4,
  icon_restoration_pontic_5,
  icon_occlusal_surface_1,
  icon_occlusal_surface_2,
  icon_occlusal_surface_3,
  icon_ceramic_metal_1,
  icon_ceramic_metal_2,
  icon_ceramic_metal_3,
  icon_ceramic_metal_4,
  icon_ceramic_metal_5,
  icon_ceramic_metal_6,
  icon_ceramic_metal_7,
  icon_ceramic_metal_8,
  icon_ceramic_metal_9,
} from 'components/base/images';

export const restorationPonticIconList = [
  { id: 1, src: icon_restoration_pontic_1 },
  { id: 2, src: icon_restoration_pontic_2 },
  { id: 3, src: icon_restoration_pontic_3 },
  { id: 4, src: icon_restoration_pontic_4 },
  { id: 5, src: icon_restoration_pontic_5 },
];
export const occlusalSurfaceIconList = [
  { id: 1, src: icon_occlusal_surface_1 },
  { id: 2, src: icon_occlusal_surface_2 },
  { id: 3, src: icon_occlusal_surface_3 },
];
export const ceramicMetalIconList = [
  { id: 1, src: icon_ceramic_metal_1 },
  { id: 2, src: icon_ceramic_metal_2 },
  { id: 3, src: icon_ceramic_metal_3 },
  { id: 4, src: icon_ceramic_metal_4 },
  { id: 5, src: icon_ceramic_metal_5 },
  { id: 6, src: icon_ceramic_metal_6 },
  { id: 7, src: icon_ceramic_metal_7 },
  { id: 8, src: icon_ceramic_metal_8 },
  { id: 9, src: icon_ceramic_metal_9 },
];
